import { Box, Button, Collapse } from "@mui/material";
import React, { Dispatch, SetStateAction } from "react";
import { CredentialResponse, UserPermissions, PendingActions } from "../../services/Types";
import PermissionCheck from "../PermissionCheck";
import { makeStyles } from "@mui/styles";
import UserCredentialsApi from "../../services/Api";

const useStyles = makeStyles({
  markVerifiedCollapseSection: {
    backgroundColor: "#fff7e8",
    position: "relative",
    margin: "0px -27px 0",
    "& p": {
      fontSize: "16px",
      color: "#323232",
      margin: "0",
    },
  },
  markVerifiedSectionInner: {
    padding: "25px 66px",
    boxShadow: "inset 0px 3px 4px rgba(0, 0, 0, 0.16)",
    borderBottom: "1px solid #dcdcdc",
    boxSizing: "border-box",
  },
  arrowCollapse: {
    position: "absolute",
    bottom: "calc(100% - 18px)",
    width: "42px",
    right: "calc(50% - 240px)",
    zIndex: "3",
  },
  arrowCollapseContentOuter: {
    position: "relative",
    width: "40.5px",
    height: "40.5px",
  },
  arrowCollapseContent: {
    height: "28.5px",
    width: "28.5px",
    position: "relative",
    backgroundColor: "#fff7e8",
    top: "calc(50% + 8px)",
    left: "50%",
    transform: "translate(-50%, -50%) rotate(45deg)",
    boxShadow: "0px -2px 3px rgba(0, 0, 0, 0.25)",
  },
  arrowCollapseContentHelper: {
    backgroundColor: "#fff7e8",
    height: "25px",
    width: "60px",
    position: "absolute",
    transform: "translateX(-50%)",
    top: "50%",
    left: "50%",
    marginTop: "8px",
  },
  markVerifiedHolder: {
    position: "relative",
  },
  markEmailVerifiedButton: {
    width: "calc(100% - 352px)",
    marginRight: "20px!important",
    backgroundColor: "#fff",
  },
  markVerifiedEmailButtonsSection: {
    margin: "7px 0 0",
  },
  markEmailVerifiedEmail: {
    fontSize: "16px",
    color: "#323232",
    fontWeight: "700",
  },
});

export const MarkVerifiedSection = ({
  userCredentials,
  userPermissions,
  executeFormAction,
  activeEmail,
  userCredentialsApi,
  userCredentialsPendingActions,
  isMarkVerifiedCollapseOpened,
  setIsMarkVerifiedCollapseOpened
}: {
  userCredentials: CredentialResponse,
  userPermissions: Array<UserPermissions>,
  executeFormAction: any,
  activeEmail: string,
  userCredentialsApi: UserCredentialsApi,
  userCredentialsPendingActions: PendingActions,
  isMarkVerifiedCollapseOpened: boolean,
  setIsMarkVerifiedCollapseOpened: Dispatch<SetStateAction<boolean>>,
}) => {
  const classes = useStyles();
    
  return (
    <PermissionCheck
      userPermissions={userPermissions}
      permissionToCheck={
        UserPermissions.VERIFY_EMAIL_ADDRESS_EDIT
      }
    >
      <div className={classes.markVerifiedHolder}>
        <Collapse
          className={classes.arrowCollapse}
          in={isMarkVerifiedCollapseOpened}
        >
          <div className={classes.arrowCollapseContentOuter}>
            <div className={classes.arrowCollapseContent}></div>
            <div
              className={classes.arrowCollapseContentHelper}
            ></div>
          </div>
        </Collapse>
        <Collapse
          className={classes.markVerifiedCollapseSection}
          in={isMarkVerifiedCollapseOpened}
        >
          <div className={classes.markVerifiedSectionInner}>
            <p>
              By clicking “Mark Email Verified” I attest I am
              following all standard security procedures.
            </p>
            <div
              className={classes.markVerifiedEmailButtonsSection}
            >
              <label>Email</label>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                }}
              >
                <div>
                  <span
                    className={classes.markEmailVerifiedEmail}
                  >
                    {activeEmail}
                  </span>
                </div>
                <div>
                  <Button
                    variant="contained"
                    disabled={userCredentials.emailVerified}
                    onClick={() => {
                        executeFormAction({
                          credentialId: userCredentials.id,
                          action: "verifyOrUpdateEmail",
                          apiMethodToCall:
                            userCredentialsApi.verifyEmail,
                          newCredentialsState: {
                            ...userCredentials,
                            emailVerified: true,
                          },
                          newPendingActionsState: {
                            require:
                              userCredentialsPendingActions.require.filter(
                                (action) =>
                                  action !== "emailVerified"
                              ),
                            optional:
                              userCredentialsPendingActions.optional.filter(
                                (action) =>
                                  action !== "emailVerified"
                              ),
                          },
                        }).then(() => {
                          setIsMarkVerifiedCollapseOpened(
                            (previousValue) => !previousValue
                          );
                        });
                      }
                    }
                  >
                    Mark Email Verified
                  </Button>
                  <Button
                    variant="outlined"
                    onClick={() => {
                      setIsMarkVerifiedCollapseOpened(
                        (previousValue) => !previousValue
                      );
                    }}
                  >
                    Cancel
                  </Button>
                </div>
              </Box>
            </div>
          </div>
        </Collapse>
      </div>
    </PermissionCheck>
  )
}